// Dependencies
import React, {useState, useEffect, useRef} from "react";
import ContentBlock from "../components/contentBlock";
import Table from "../components/Table";
import Pagination from "../components/pagination";
import Loading from "../components/loading";

import { connect } from "react-redux";
import {getBillingStatements, getFinancialStatements} from "../actions/financial_statements";
import { getDocDetail } from "../actions/documents";
import { destroyAsset, createAssetResource} from "../actions/balance";

import AssetsResourcesModal from "./balance/details/assetsResourcesModal";
import AlertModal from "../components/alertModal";

//Components
import SelectMultiple from "../components/selectMultiple";
import Icon from "../components/icons/";

const FinancialStatements = (props) => {
  let date = new Date()
  date.setFullYear( date.getFullYear() - 1 );


  const [step, setStep] = useState("daily");
  const [elementType, setElementType] = useState("general");
  const [tabActive, setTabActive] = useState(0);
  const [yearSelected, setYearSelected] = useState("");
  const [data, setData] = useState({});
  const [modalData, setModalData] = useState({});
  const [showDeleteModalDocument, setShowDeleteModalDocument] = useState({});
  const [successModal, setSuccessModal] = useState({});

  const [monthSelected, setMonthSelected] = useState("");
  const [monthSelectedId, setMonthSelectedId] = useState(null);
  const [showMonthSelect, setShowMonthSelect] = useState(true);
  const [loading, setLoading] = useState(false)
  const [billingStep, setBillingStep] = useState("current");
  const [billingTabActive, setBillingTabActive] = useState(0);
  

  const selectMultiple = useRef(null)
  const billingStepRef = useRef("current")
  const currentYear = new Date().getFullYear();
  const billingFilterYears = data.filter_year || [];
  const billingHistoricalYears = billingFilterYears.filter((year) => parseInt(year.value, 10) !== currentYear);
  const hasBillingHistorical = billingHistoricalYears.length > 0;
  const billingTabs = [
    { code: "current", title: props.language !== "es-ES" ? "Current Year" : "Año Actual" },
    ...(hasBillingHistorical ? [{ code: "historical", title: props.language !== "es-ES" ? "Historical" : "Históricos" }] : []),
  ];
  const showFilters = !props.billing || billingStep === "historical";
  const yearOptions = props.billing && billingStep === "historical" ? billingHistoricalYears : data.filter_year;

  const fetchStatements = (params, successCallback = success, errorCallback = error) => {
    const request = props.billing ? props.getBillingStatements : props.getFinancialStatements;

    request(
      props.authentication_token,
      (responseJSON) => successCallback(responseJSON),
      () => errorCallback(),
      params
    )
  }

  useEffect(() => {
    let frequency_selected = getUrlVars()["frequency"]
    let type_selected = getUrlVars()["type"]

    let document_id = getUrlVars()["document_id"]
    
    let params = props.billing ? {} : {date: props.date}
    if(frequency_selected !== undefined){
        params["frequency"] = frequency_selected
       
    }
    if(type_selected !== undefined){
        params["type"] = type_selected
        setElementType(type_selected)
    }
    setLoading(true)
    fetchStatements(params, (responseJSON) => {
      if (props.billing && billingStepRef.current !== "current") return;

      success(responseJSON, frequency_selected, document_id)
    })


    // props.getBreadcrumbs({
    //   assetUrl: "/financial-statements",
    //   url:"/financial-statements",
    //   assetTitle: ""
    // });

  }, []);  

  useEffect(() => {
    if (!props.billing || billingStep !== "historical" || hasBillingHistorical) return;

    billingStepRef.current = "current";
    setBillingStep("current");
    setBillingTabActive(0);
    setYearSelected("");
    setMonthSelected("");
    setMonthSelectedId(null);
  }, [props.billing, billingStep, hasBillingHistorical]);

  const error = () => {
    console.log("error")
    setLoading(false)
  }

  const success = (responseJSON, frequency_selected, document_id) => {
    if(frequency_selected !== undefined){
        setStep(frequency_selected);
        setTabActive(getTabActiveByStep(responseJSON, frequency_selected))
    }
    if(document_id !== undefined){
      showDocument("documents/documents/"+document_id)
    }
    setData(responseJSON)
    if(!props.billing && responseJSON.filter_year.length > 0 && yearSelected === ""){
      setYearSelected(responseJSON.filter_year[0].value)
    }
    
    setLoading(false)
  }

  const getTabActiveByStep = (responseJSON, frequency_selected) => {
    return responseJSON.tabs.map(e => e.code).indexOf(frequency_selected);
  }
  const getUrlVars = () => {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
  }
  const changeStepTab = (tab, index) => {
    console.log(tab, index)
    // pieChart && resetPieChart();
    // setPieSelectedElement(-1);
    setStep(data.tabs[index].code);
    setTabActive(index)
    setYearSelected("")
    setMonthSelected("")
    setMonthSelectedId(null)
    setShowMonthSelect(false)
    setLoading(true)
    fetchStatements({type: elementType, frequency: data.tabs[index].code, date: props.date})
    // props.setStep(data.tabs[index].code);
    // window.history.pushState(
    //   "",
    //   "",
    //   "balance-show?url=balance_principal/financial_assets&code=" +
    //   data.tabs[index].code
    // );
    // setPieChart(null);
  };

  const changeBillingStepTab = (tab, index) => {
    billingStepRef.current = tab.code;
    setBillingStep(tab.code);
    setBillingTabActive(index);
    setMonthSelected("");
    setMonthSelectedId(null);
    setShowMonthSelect(true);
    setLoading(true);

    if (tab.code === "current") {
      setYearSelected("");
      fetchStatements({}, (responseJSON) => {
        if (billingStepRef.current !== "current") return;

        setData(responseJSON);
        setYearSelected("");
        setLoading(false);
      });
    } else {
      const historicalYears = data.filter_year && data.filter_year.filter((year) => parseInt(year.value, 10) !== currentYear);
      const selectedYear = historicalYears && historicalYears[0] ? historicalYears[0].value : "";
      setYearSelected(selectedYear);
      if (selectedYear === "") {
        setData({
          ...data,
          table: {
            ...data.table,
            rows: [],
            total_pages: 0,
            current_page: 1,
            all_ids: []
          }
        });
        setLoading(false);
      } else {
        fetchStatements({year: selectedYear}, (responseJSON) => {
          if (billingStepRef.current !== "historical") return;

          setData(responseJSON);
          setYearSelected(selectedYear);
          setLoading(false);
        });
      }
    }
  };

  const successDetailDoc = (responseJSON, url, edit_mode = false) => {
    setModalData({
        idMain: "",
        id: responseJSON.identifier.id,
        form: responseJSON.form.edit_document.inputs,
        resource_key: responseJSON.form.edit_document.resource_key,
        can_manage: responseJSON.form.edit_document.can_manage,        
        url: url,
        title: responseJSON.title,
        show_title: responseJSON.show_title,
        edit_title: responseJSON.edit_title,        
        method: responseJSON.actions[0].method,
        code: responseJSON.actions[0].code,
        linked: responseJSON.assets.length > 1,
        edit_mode: edit_mode
      }
    )
  }

  const showDocument = (url, edit_mode = false) =>  {
    props.getDocDetail(
      props.authentication_token,
      responseJSON => successDetailDoc(responseJSON, url, edit_mode),
      () => this._error(),
      url

    );
  }

  const deleteDocument = (item, url) => {
    setShowDeleteModalDocument({
        title: props.internalization.alerts.delete_asset,
        subtitle: item.linked ? props.internalization.alerts.delete_document_linked : props.internalization.alerts.delete_asset_confirmation,
        url: url,
        method: "DELETE"
      })
    setModalData({})
  }

  const successDeleteAssetDocument = () => {
    setLoading(true)
    fetchStatements({type: elementType, frequency: step, date: props.date})
    setShowDeleteModalDocument({})

  }

  const successCreateAssetResource = (edit, key, modalData) => {
    let key_fix = ["owner_beneficiary"].includes(key)
      ? modalData.code === "edit_owner"
        ? "owner_life_insurance"
        : "beneficiary_life_insurance"
      : key;
      setModalData({})
    setSuccessModal({
      modal_title: edit
        ? props.internalization.modals[key_fix].updated.title
        : props.internalization.modals[key_fix].created.title,
      modal_body: edit
        ? props.internalization.modals[key_fix].updated.body
        : props.internalization.modals[key_fix].created.body,
    });
  }
  const updateDocument = (data) => {
   props.createAssetResource(
      props.authentication_token,
      () =>
        successCreateAssetResource(
          modalData.method === "PUT",
          modalData.resource_key,
          modalData
        ),
      () => console.log("error updating"),
      modalData.url,
      modalData.method,
      data
    ); 
  }
   
  return (
    <div>
    { loading && 
      <Loading 
            simple 
            width={96} 
            height={96} 
            style={{marginTop: -12}}
          />
    }
      {props.billing && (
        <div className="c-tabs__wrapper">
          <div className="c-tabs__container">
            {billingTabs.map((tab, index) => (
              <div
                key={tab.code}
                onClick={() => changeBillingStepTab(tab, index)}
                className={`c-tabs ${billingTabActive === index ? "is-active" : ""}`}
              >
                <span className="c-tabs__text">{tab.title}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      

      {data.table && (
        <div>
          <div className="c-tabs__content-top">
            <ContentBlock
              header={false}
              maxHeight={false}
              className="centered-and-full"
              wrapperStyle={{ marginRight: 0 }}
            >

              <div>
              {showFilters && (
                <>
                <p style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{props.billing ? (props.language !== "es-ES" ? "Choose the year of the invoice you want to check" : "Escoge el año de la factura que quieres consultar") : (props.language !== "es-ES" ? "Choose the year of the report you want to check" :  "Escoge el año del reporte que quieres consultar")}</p>
                <div style={{marginBottom: 24}}>

                  <SelectMultiple
                    colorGrey={true}
                    setRef={(ref) => selectMultiple}
                    defaultValue={yearSelected}
                    label={"Year"}
                    options={yearOptions}
                    multiple={false}
                    openOptions={() =>
                      console.log("open options")
                      // etState({
                      //   modalOptions: !modalOptions,
                      // })
                    }
                    disabled={false}
                    // modalOptions={this.state.modalOptions}
                    getOptions={(items) => {
                        setData({})
                        setYearSelected(items.item.value)
                        setMonthSelected("")
                        setMonthSelectedId(null)
                        setLoading(true)
                        fetchStatements(props.billing ? {year: items.item.value} : {type: elementType, frequency: step, year: items.item.value, step: step, date: props.date})
                        setShowMonthSelect(!props.billing);
                        }
                    }
                    // itemsSelected={
                    //   this.state.inputsValue.type !== undefined
                    //     ? this.state.inputsValue.type
                    //     : []
                    // }
                  />
                  {!props.billing && showMonthSelect && (
                    <div style={{marginTop: 18, display: 'flex', justifyContent: "center", alignItems: "center"}}>

                      <SelectMultiple
                        colorGrey={true}
                        setRef={(ref) => selectMultiple}
                        defaultValue={monthSelected}
                        label={"Month"}
                        options={data.filter_months}
                        multiple={false}
                        openOptions={() =>
                          console.log("open options")
                          // etState({
                          //   modalOptions: !modalOptions,
                          // })
                        }
                        disabled={false}
// modalOptions={this.state.modalOptions}
                        getOptions={(items) => {
                          setData({})
                          setMonthSelected(items.item.value)
                          setMonthSelectedId(items.item.id)
                          setLoading(true)
                          fetchStatements(props.billing ? {year: yearSelected, month: items.item.id} : {type: elementType, frequency: step, year: yearSelected, month: items.item.id, step: step, date: props.date})
                        }}
// itemsSelected={
                        //   this.state.inputsValue.type !== undefined
                        //     ? this.state.inputsValue.type
                        //     : []
                        // }
                      />
                    {
                      monthSelected !== "" &&
                      <div style={{ position: "relative"}}>
                      <div
                        className=""
                        style={{
                          widht: 20,
                          transform: "rotate(-45deg) translate(-3px, 12px)",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setData({})
                          setMonthSelected("")
                          setMonthSelectedId(null)
                          setLoading(true)
                          fetchStatements(props.billing ? {year: yearSelected, month: ""} : {type: elementType, frequency: step, year: yearSelected, month: "", step: step, date: props.date})
                        }
                        }
                      >
                        <Icon name="Plus" noWrapper={true} />
                      </div>
                  </div>
                    }
                    
                    </div>

                  )}


                </div>
                </>
              )}

                <Table
                  // showSearcher={
                  //   props.dataTable.documents.table.total_pages !== 1 ||
                  //     (searchText["documents"] !== undefined && searchText["documents"] !== "")
                  // }
                  dataTable={data.table}
                  fullWidth={true}
                  action={props.billing ? null : {
                    title: "Action",
                    show: (el) => showDocument(el.url, false),
                    edit: (el) => showDocument(el.url, true),
                  }}
                  // searchText={searchText["documents"]}
                  // search={(text) =>
                  //   props.paginateTab(
                  //     { text: text, source: "documents", page: 1, type: "get_documents" },
                  //     () => setSearchText({ ...searchText, ["documents"]: text }),
                  //     () => ""
                  //   )
                  // }
                  all_ellipsis={true}
                />
                {data.table.rows.length > 0 &&
                  data.table.total_pages > 1 && (
                    <div className="c-tabs__content-bottom">
                      <Pagination
                        goTo={(page) => {
                          setData({})
                          setLoading(true)
                          if (props.billing && billingStep === "current") {
                            fetchStatements({page: page})
                          } else if (props.billing) {
                            fetchStatements({year: yearSelected, page: page})
                          } else {
                            fetchStatements({year: yearSelected, month: monthSelectedId, page: page, step: step, date: props.date})
                          }
                        }}
                        pages={Array.from(
                          { length: data.table.total_pages },
                          (v, k) => k + 1
                        )}
                        currentPage={data.table.current_page}
                      />
                    </div>
                  )}
              </div>
            </ContentBlock>
          </div>
        </div>
      )}
      {Object.keys(showDeleteModalDocument).length > 0 && (
        <AlertModal
          isShowed={Object.keys(showDeleteModalDocument).length > 0}
          title={props.internalization.modals.document.delete.title}
          msg={props.internalization.modals.document.delete.body}
          action={() => {
            props.destroyAsset(
              props.authentication_token,
              () => successDeleteAssetDocument(),
              () => alert("error"),
              showDeleteModalDocument.url,
              showDeleteModalDocument.method
            );
          }}
          textButton="Yes"
          textButtonAlertColor={true}
          cancelButton={true}
          cancelTextButton="Cancel"
          cancelButtonAlertColor={false}
          actionCancelButton={() => {
            setShowDeleteModalDocument({})
          }}
        />
        )}
        {Object.keys(modalData).length > 0 && (
            <AssetsResourcesModal
              language={props.language}
              identifier={""}
              colorGrey={true}
              data={modalData}
              errors={props.errors}
              closeModal={e => {
                if (
                  e.target.className === "modal-wrapper" ||
                  (e.target.closest(".modal-header") !== null &&
                    e.target.closest(".modal-header").className.includes("modal-header"))
                ) {
                  setModalData({})
                }
              }}
              uploadResource={data => updateDocument(data)}
              resources={[]}
              goToResource={asset => ""}
              polymorphic={
                modalData.resource_key === "contact"
                  ? "resourceable_"
                  : "ownerable_"
              }
              showDocument={url => props.showDocument(url)}
              showContact={(url, idMain) => ""}
              resourceToSelectDestroy={true}
              resourceDestroyAction={url => ""}
              destroyAssetAssociated= {() => ""}
              deleteDocument={(url) => modalData.resource_key === "document" ? deleteDocument(modalData, modalData.url) : ""}
              buttons={props.internalization.buttons}
              showModalSessionExpire={(time_left, diffMins, checkTime) => props.showModalSessionExpire(time_left, diffMins, () => checkTime())}
              getLinkForm = {(url, success_fromblock, error_fromblock) => props.getLinkForm(url, props.authentication_token, (responseJSON) => "", () => "")}
            />
          )}
        {Object.keys(successModal).length > 0 && (
          <AlertModal
            isShowed={true}
            title={successModal.modal_title}
            msg={successModal.modal_body}
            action={() => {
              setSuccessModal({})
              setLoading(true)
              fetchStatements({type: elementType, frequency: step, date: props.date})

            }}
            textButton={props.internalization.buttons.ok}
          />
        )}        
    </div>
  );

};

function mapStateToProps(state) {
  return {
    authentication_token: state.session.authentication_token,
    internalization: state.session.internalization,
    errors: state.session.errors,

  };
}

function mapDispatchToProps(dispatch) {
  return {
    getFinancialStatements: (authentication_token, success, error, params) =>
      dispatch(getFinancialStatements(authentication_token, success, error, params)),
    getBillingStatements: (authentication_token, success, error, params) =>
      dispatch(getBillingStatements(authentication_token, success, error, params)),
    getDocDetail: (authentication_token, success, error, url) =>
      dispatch(getDocDetail(authentication_token, success, error, url)),
    destroyAsset: (authentication_token, success, error, url, method) =>
      dispatch(destroyAsset(authentication_token, success, error, url, method)),
    createAssetResource: ( authentication_token, success, error, url, method, attributes) => dispatch( createAssetResource( authentication_token, success, error,url, method, attributes)),

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FinancialStatements);
